import { configureStore } from '@reduxjs/toolkit';
import createReducer from './rootReducer';
import rootSaga from './rootSaga';
import createSagaMiddleware from 'redux-saga';

const sagaMiddleware = createSagaMiddleware();

const store = configureStore({
  reducer: createReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      thunk: false, // Disable thunk middleware if you're only using sagas
      immutableCheck: false,
      serializableCheck: false,
    }).concat(sagaMiddleware)
});

store.runSaga = sagaMiddleware.run;
sagaMiddleware.run(rootSaga);

export default store;
